module.exports = __webpack_public_path__ + "static/media/login_right_bg@2x.d65a44a7.png";